import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWpInstanceStatus, createWpInstance } from '../../store/slices/wpConfigSlice';
import { Button, Alert, Spin } from 'antd';
import QRCode from 'react-qr-code';

const PANEL_URL = 'https://panel.sporokulutakip.com';

const StatusDot = ({ color }) => (
  <span style={{
    display: 'inline-block',
    width: 12,
    height: 12,
    borderRadius: '50%',
    background: color,
    marginRight: 8,
    verticalAlign: 'middle',
    boxShadow: `0 0 4px ${color}`
  }} />
);

const WpPage = () => {
  const dispatch = useDispatch();
  const { status: fetchStatus, instance } = useSelector(state => state.wpConfig);
  const selectedBranch = useSelector(state => state.branches.selectedBranch);
  const selectedPlace = useSelector(state => state.branches.selectedPlace);
  const intervalRef = useRef();
  const [createError, setCreateError] = useState(null);
  
  const wpStatus = instance && instance.success && instance.status ? instance.status : null;
  const isInstanceNotFound = instance && (
    instance.message === 'Instance bulunamadı.' ||
    wpStatus === null ||
    (wpStatus && wpStatus.status === 'disconnected')
  );
  const loading = fetchStatus === 'loading';

  useEffect(() => {
    if (selectedBranch?.id) {
      dispatch(fetchWpInstanceStatus({ branchId: selectedBranch.id, placeId: selectedPlace?.id }));
    }
  }, [dispatch, selectedBranch?.id]);

  const wpConnectionStatus = wpStatus?.status;
  useEffect(() => {
    if (wpConnectionStatus && wpConnectionStatus !== 'connected' && selectedBranch?.id) {
      intervalRef.current = setInterval(() => {
        dispatch(fetchWpInstanceStatus({ branchId: selectedBranch.id, placeId: selectedPlace?.id }));
      }, 60000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [dispatch, wpConnectionStatus, selectedBranch?.id]);

  const handleRefresh = () => {
    if (selectedBranch?.id) dispatch(fetchWpInstanceStatus({ branchId: selectedBranch.id, placeId: selectedPlace?.id }));
  };

  const handleCreateInstance = async () => {
    setCreateError(null);
    if (!selectedBranch?.id) return;
    const result = await dispatch(createWpInstance({ branchId: selectedBranch.id, placeId: selectedPlace?.id }));
    if (result.payload && result.payload.success) {
      dispatch(fetchWpInstanceStatus({ branchId: selectedBranch.id, placeId: selectedPlace?.id }));
    } else {
      setCreateError('Entegrasyon oluşturulamadı, lütfen tekrar deneyin.');
    }
  };

  const showNotConnected = wpStatus && (wpStatus.status === 'qr_pending' || wpStatus.status === 'initializing');

  return (
    <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
          <Spin size="large" tip="Yükleniyor..." />
        </div>
      )}
      {!loading && (
      <div style={{ width: 320, margin: '40px auto 0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {isInstanceNotFound && (
          <>
            <Alert type="warning" showIcon message="Henüz bir WhatsApp entegrasyonu yok." style={{ marginBottom: 24, width: '100%' }} />
            {createError && <Alert type="error" showIcon message={createError} style={{ marginBottom: 16, width: '100%' }} />}
            <Button type="primary" size="large" onClick={handleCreateInstance}>Yeni Entegrasyon Oluştur</Button>
          </>
        )}
        {!isInstanceNotFound && instance && instance.success === false && (
          <Alert type="error" showIcon message={instance.message || 'Bir hata oluştu.'} style={{ marginBottom: 24, width: '100%' }} />
        )}
        {showNotConnected && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
              <StatusDot color="#ff4d4f" />
              <span style={{ fontWeight: 600, fontSize: 18 }}>Bağlı değil</span>
            </div>
            {wpStatus.status === 'qr_pending' && wpStatus.qr && (
              <div style={{ background: '#fff', padding: 24, borderRadius: 16, boxShadow: '0 2px 8px #f0f1f2', marginBottom: 24 }}>
                <QRCode value={wpStatus.qr} size={200} />
              </div>
            )}
            {wpStatus.status === 'qr_pending' && !wpStatus.qr && (
              <Button type="dashed" size="large" onClick={handleRefresh} style={{ marginBottom: 24 }}>QR Yenile</Button>
            )}
            {wpStatus.status === 'initializing' && (
              <div style={{ background: '#fff', padding: 24, borderRadius: 16, boxShadow: '0 2px 8px #f0f1f2', marginBottom: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200 }}>
                <Button type="dashed" size="large" onClick={handleRefresh}>QR Yenile</Button>
              </div>
            )}
            {wpStatus.status === 'qr_pending' && wpStatus.qr && (
              <Button type="primary" size="large" onClick={handleRefresh}>Okuttum</Button>
            )}
          </>
        )}
        {!isInstanceNotFound && wpStatus && wpStatus.status === 'connected' && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
              <StatusDot color="#52c41a" />
              <span style={{ fontWeight: 600, fontSize: 18 }}>Bağlandı</span>
            </div>
            <div style={{ background: '#f5f5f5', padding: 24, borderRadius: 16, boxShadow: '0 2px 8px #f0f1f2', marginBottom: 24, opacity: 0.5, pointerEvents: 'none' }}>
              <QRCode value={PANEL_URL} size={200} />
            </div>
          </>
        )}
      </div>
      )}
    </div>
  );
};

export default WpPage; 